import { Injectable, Injector, ElementRef } from '@angular/core';

import { DATEPICKER_INPUT_DIRECTIVE } from './datepicker-input/datepicker-input.token';
import { DatepickerInputDirective } from './datepicker-input/datepicker-input.directive';
import { DatepickerCalendarComponent } from './datepicker-calendar/datepicker-calendar.component';
import { PopoverService, PopoverOptions } from './popover/popover.service';
import { PopoverRef } from './popover/popover-ref';

@Injectable()
export class DatepickerOverlayService {
  popover: PopoverRef;

  constructor(
    private injector: Injector,
    private popoverSvc: PopoverService,
  ) { }

  open(datepickerElement: ElementRef, datepickerInput: DatepickerInputDirective) {
    const injector = this.createInjector(datepickerInput, this.injector);

    const options: PopoverOptions = {
      modalPopover: true,
      injector: injector,
      customClasses: 'cf-datepicker-popper',
    };
    this.popover = this.popoverSvc.showPopover(datepickerElement.nativeElement, DatepickerCalendarComponent, options);
  }

  close() {
    if (this.popover && this.popover.isShown) {
      this.popover.destroy();
    }
  }

  opened(): boolean {
    if (this.popover) {
      return this.popover.isShown;
    }
  }

  /**
   * Returns a reference to the host element aka the
   * datepicker calendar
   */
  get overlayElement() {
    if (this.popover && this.popover.isShown) {
      return this.popover.element;
    }
  }

  private createInjector(datepickerInput: DatepickerInputDirective, injector: Injector): Injector {
    return Injector.create({
      parent: injector,
      providers: [{ provide: DATEPICKER_INPUT_DIRECTIVE, useValue: datepickerInput }],
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/datepicker-overlay.service.ts